import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const SettingsLayout = ({ title, subtitle, children }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-3xl mx-auto pb-20">
      {/* Header with back button */}
      <div className="flex items-start gap-3 mb-8">
        <button
          onClick={() => navigate('/dashboard/profile')}
          className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center hover:bg-gray-50 transition-colors shrink-0 mt-1"
        >
          <ChevronLeft size={20} className="text-gray-600" />
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="text-3xl font-serif font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-gray-500 mt-1">{subtitle}</p>}
        </div>
      </div>

      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default SettingsLayout;